import SectionHeading from "@/components/base/SectionHeading";
import { rankings } from "@/mocks/ranking";

const trendMap: Record<string, { icon: string; label: string; className: string }> = {
  up: { icon: "ri-arrow-up-line", label: "上升", className: "text-primary-600" },
  down: { icon: "ri-arrow-down-line", label: "下降", className: "text-foreground-400" },
  flat: { icon: "ri-subtract-line", label: "持平", className: "text-secondary-600" },
};

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full bg-foreground-950 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-3 py-1 text-xs font-medium text-accent-300">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-500" aria-hidden="true" />
              人气榜单
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
              本月口碑排行：读者投票与测评评分综合得出
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-200 md:text-base">
              榜单每月更新一次，综合读者推荐数量、复购意愿与我们的实地评分数值。箭头表示与上月相比的名次变化。
            </p>
          </div>
          <a
            href="#reviews"
            className="inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
          >
            <i className="ri-file-list-3-line" aria-hidden="true" />
            查看全部测评
          </a>
        </div>

        <ol className="mt-10 flex flex-col gap-2.5">
          {rankings.map((item) => {
            const trend = trendMap[item.trend];
            const isTop = item.rank <= 3;
            return (
              <li
                key={item.id}
                className={`flex flex-wrap items-center gap-x-5 gap-y-3 rounded-lg border px-4 py-4 md:px-6 ${
                  item.rank === 1
                    ? "border-accent-500/60 bg-background-50/10"
                    : "border-background-50/10 bg-background-50/5"
                }`}
              >
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold ${
                    isTop ? "bg-accent-500 text-foreground-950" : "bg-background-50/10 text-background-200"
                  }`}
                >
                  {item.rank}
                </span>
                <div className="flex min-w-[140px] flex-1 flex-col">
                  <span className="font-heading text-base font-bold text-background-50">{item.name}</span>
                  <span className="mt-0.5 text-xs text-background-300">
                    {item.category} · 人均 {item.price}
                  </span>
                </div>
                <p className="hidden max-w-md flex-1 text-xs leading-relaxed text-background-300 lg:block">
                  {item.comment}
                </p>
                <span className={`flex items-center gap-1 text-xs font-medium ${trend.className}`}>
                  <i className={trend.icon} aria-hidden="true" />
                  {trend.label}
                </span>
                <span className="flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-accent-300">
                  <i className="ri-star-fill" aria-hidden="true" />
                  {item.score.toFixed(1)}
                </span>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}